import { isLandlordUser, isStaffUser } from '../../utils/user'

// Falling back to the inhabitant key while the role is unknown (loading) keeps
// the pre-branching behavior.
export function getUserProfilePageBrowserTabTitleKey(userData) {
  return userData?.isStaff ? 'BrowserTab.StaffProfileTabTitleKey' : null
}

export function getUserProfilePreparedData(data) {
  return data
    ? {
        ...data,
        archivedAt: data.archived_at,
        companyPostName: data.company_post_name,
        createdAt: data.created,
        createdBy: data.created_by,
        externalId: data.external_id,
        functionalRole: data.functional_role,
        invitedAt: data.invited_at,
        isArchived: data.archived,
        isLandlord: isLandlordUser(data),
        isStaff: isStaffUser(data),
        lastLoginAt: data.last_login,
        registeredAt: data.registered_at,
        ssoId: data.sso_external_id,
        updatedAt: data.updated,
        updatedBy: data.updated_by,
      }
    : null
}
